/*
 * jQuery ajaxPool Plugin v1.0
 * http://outwestmedia.com/jquery-plugins/ajaxpool/
 *
 * Released: 2009-09-28
 * Version: 1.0
 * 
 * Copyright (c) 2009 Jonathan Sharp, Out West Media LLC.
 * Dual licensed under the MIT and GPL licenses.
 * http://docs.jquery.com/License
 */
(function($) {
	$.extend({
		// Contains a named hash of the connections
		ajaxConnectionPool: {},
		
		/*
		 * This method take a pool name (optional) otherwise it operates on all connections.
		 * It will then abort each XHR request.
		 */
		ajaxAbort: function(pool) {
			if (arguments.length == 0) {
				for (var pool in $.ajaxConnectionPool) {
					$.ajaxAbort(pool);
				}
				return true;
			}
			if ($.ajaxConnectionPool[pool]) {
				for (var i in $.ajaxConnectionPool[pool]) {
				    try {
				        // CJS - check for [i] null, abort is null, abort is a funct.
				        if ($.ajaxConnectionPool[pool][i] && $.ajaxConnectionPool[pool][i].abort && $.isFunction($.ajaxConnectionPool[pool][i].abort)) {
				            $.ajaxConnectionPool[pool][i].abort();
				        }
						$.ajaxConnectionPool[pool][i] = null;
						delete $.ajaxConnectionPool[pool][i];
					} catch (e) { };
				}
				return true;
			}
			return false;
		},
		// Cleans the ajaxRequest queue for connections that were non-global
		ajaxCleanPool: function() {
			for (var pool in $.ajaxConnectionPool) {
				for (var i in $.ajaxConnectionPool[pool]) {
					if ($.ajaxConnectionPool[pool][i] === null
						|| $.ajaxConnectionPool[pool][i].readyState == 4
						|| $.ajaxConnectionPool[pool][i].readyState == 0) {
						try {
							$.ajaxConnectionPool[pool][i] = null;
							delete $.ajaxConnectionPool[pool][i];
						} catch (e) { }
					}
				}
			}
		}
	});
	/*
	 * These methods are hooks into the main connection handling. 
	 */
	$.ajaxSetup({
		// This method stores a reference to the XHR request object for use in 
		// calling abort later, additionally it handles the newly introduced 
		// 'pool' attribute
		beforeSend: function(xhr, settings) {
			settings = $.extend({ pool: 'default' }, settings);
			if (!$.ajaxConnectionPool[settings.pool]) {
				$.ajaxConnectionPool[settings.pool] = [];
			}
			$.ajaxConnectionPool[settings.pool].push(xhr);
			// Clean up requests that weren't global
			if (settings.global === false) {
				setTimeout(function() {
					$.ajaxCleanPool();
				}, 1500);
			}
		},
		// Cleanup method to delete the connection objects
		complete: function(xhr, settings) {
			settings = $.extend({ pool: 'default' }, settings);
			if ($.ajaxConnectionPool[settings.pool]) {
				for (var i in $.ajaxConnectionPool[settings.pool]) {
					if ($.ajaxConnectionPool[settings.pool][i] === xhr) {
						$.ajaxConnectionPool[settings.pool][i] = null;
						try {
							delete $.ajaxConnectionPool[settings.pool][i];
						} catch (e) { };
						break;
					}
				}
			}
		}
	});
})(jQuery);